import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SponsorPortalComponent } from './sponsor-portal.component';
import { SponsorPermitsComponent } from './components/sponsor-permits/sponsor-permits.component';
import { SponsorRequestsComponent } from './components/sponsor-requests/sponsor-requests.component';
import { SponsorResultsComponent } from './components/sponsor-results/sponsor-results.component';

import { NewPermitModule } from 'src/app/routed-pages/new-permit/new-permit.module';
import { PermitsModule } from 'src/app/routed-pages/permits/permits.module';



@NgModule({
  declarations: [SponsorPortalComponent, SponsorPermitsComponent, SponsorRequestsComponent, SponsorResultsComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([
      { path: 'sponsor-portal', component: SponsorPortalComponent },
      { path: 'sponsor-permits', component: SponsorPermitsComponent },
      { path: 'sponsor-requests', component: SponsorRequestsComponent },
      { path: 'sponsor-results', component: SponsorResultsComponent}
    ]),
    NgbModule,
    NewPermitModule,
    PermitsModule
  ]
})
export class SponsorPortalModule { }
